import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["target"];
import A, { Fragment as i, createContext as G, useContext as L, useEffect as s, useRef as T, useState as m } from "react";
import { createPortal as x } from "react-dom";
import { forwardRefWithAs as P, render as d } from '../../utils/render.js';
import { useIsoMorphicEffect as b } from '../../hooks/use-iso-morphic-effect.js';
import { usePortalRoot as h } from '../../internal/portal-force-root.js';
import { useServerHandoffComplete as C } from '../../hooks/use-server-handoff-complete.js';
import { optionalRef as v, useSyncRefs as R } from '../../hooks/use-sync-refs.js';
import { useOwnerDocument as g } from '../../hooks/use-owner.js';
import { microTask as M } from '../../utils/micro-task.js';
import { env as E } from '../../utils/env.js';

function H(u) {
  var a = h(),
      o = L(c),
      e = g(u),
      _m = m(function () {
    if (!a && o !== null || E.isServer) return null;
    var t = e == null ? void 0 : e.getElementById("headlessui-portal-root");
    if (t) return t;
    if (e === null) return null;
    var r = e.createElement("div");
    return r.setAttribute("id", "headlessui-portal-root"), e.body.appendChild(r);
  }),
      _m2 = _slicedToArray(_m, 2),
      l = _m2[0],
      n = _m2[1];

  return s(function () {
    l !== null && (e != null && e.body.contains(l) || e == null || e.body.appendChild(l));
  }, [l, e]), s(function () {
    a || o !== null && n(o.current);
  }, [o, n, a]), l;
}

var O = i;

function _(u, a) {
  var o = u,
      e = T(null),
      l = R(v(function (p) {
    e.current = p;
  }), a),
      n = g(e),
      t = H(e),
      _m3 = m(function () {
    var p;
    return E.isServer ? null : (p = n == null ? void 0 : n.createElement("div")) != null ? p : null;
  }),
      _m4 = _slicedToArray(_m3, 1),
      r = _m4[0],
      y = C(),
      f = T(!1);

  return b(function () {
    if (f.current = !1, !(!t || !r)) return t.contains(r) || (r.setAttribute("data-headlessui-portal", ""), t.appendChild(r)), function () {
      f.current = !0, M(function () {
        var p;
        f.current && (!t || !r || (r instanceof Node && t.contains(r) && t.removeChild(r), t.childNodes.length <= 0 && ((p = t.parentElement) == null || p.removeChild(t))));
      });
    };
  }, [t, r]), y ? !t || !r ? null : x(d({
    ourProps: {
      ref: l
    },
    theirProps: o,
    defaultTag: O,
    name: "Portal"
  }), r) : null;
}

var F = i,
    c = G(null);

function U(u, a) {
  var o = u.target,
      e = _objectWithoutProperties(u, _excluded),
      n = {
    ref: R(a)
  };

  return A.createElement(c.Provider, {
    value: o
  }, d({
    ourProps: n,
    theirProps: e,
    defaultTag: F,
    name: "Popover.Group"
  }));
}

var S = P(_),
    j = P(U),
    te = Object.assign(S, {
  Group: j
});
export { te as Portal };